import { TopToolbar } from 'react-admin'
import { Select, Box, MenuItem, FormControl, InputLabel } from '@mui/material'
import ExportExcelButton from './ExportExcelButton'

const getMonthOptions = () => {
  const options = []
  const frenchMonths = [
    'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
  ]
  
  const startDate = new Date(2024, 9) // October 2024
  const currentDate = new Date()
  
  let iterDate = new Date(startDate)
  
  // Stop iterating before the current month
  while (iterDate < new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)) {
    const year = iterDate.getFullYear()
    const month = iterDate.getMonth()
    const value = `${year}-${month + 1}`.padStart(7, '0') // Ensure format like YYYY-MM
    const label = `${frenchMonths[month]} ${year}`
    
    options.unshift({ value, label })
    iterDate.setMonth(iterDate.getMonth() + 1)
  }
  
  return options
}

const MonthToolbar = ({ selectedMonth, setSelectedMonth }) => {
  const monthOptions = getMonthOptions()
    
  return (
    <TopToolbar>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box>
          <FormControl variant="outlined" sx={{ minWidth: 300 }}>
            <InputLabel id="month-filter-label">Filtrer par mois d'import</InputLabel>
            <Select
              labelId="month-filter-label"
              id="month-filter"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              label="Filtrer par mois"
            >
              <MenuItem value="">Tous les mois</MenuItem>
              {monthOptions.map(({ value, label }) => (
                <MenuItem key={value} value={value}>{label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <ExportExcelButton selectedMonth={selectedMonth} />
      </Box>
    </TopToolbar>
  )
}

export default MonthToolbar